import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { MetricsApiService } from './metrics-api.service';
import { switchMap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { QueryParams } from '@/app/core/http/query-params';
import * as _ from 'lodash';
import { AuthenticationService } from '../../core/authentication/authentication.service';
import { ActiveFilterService } from './../query/active-filter.service';
import { RequestCancellationService } from '../http/request-cancellation.service';

/**
 * Handles API calls used for filter profiles.
 */
export class FilteredMetricsApiService extends MetricsApiService {
  constructor(
    protected http: HttpClient,
    protected authenticationService: AuthenticationService,
    private filterService: ActiveFilterService,
    protected cancellationService: RequestCancellationService
  ) {
    super(http, authenticationService, cancellationService);
  }

  public async applyFiltersToRequestBody(
    postData: any,
    exclude = []
  ): Promise<any> {
    await this.authenticationService.getAuthToken().toPromise();
    const target: any = {};
    if (
      this.authenticationService &&
      this.authenticationService._userInfoView &&
      this.authenticationService._userInfoView.SelectedClient
    ) {
      target.ClientId =
        this.authenticationService._userInfoView.SelectedClient.ClientID.toString();
    }

    const params = this.filterService.getFilterParams();

    const result = Object.assign(target, postData, params);
    return result;
  }
}
